import React from 'react';

function formatLabel(key) {
    return key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function UberRideInfoModal({ show, rideInfo, loading, onClose }) {
    if (!show) return null;

    const entries = rideInfo ? Object.entries(rideInfo) : [];

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '6px',
                    padding: '0',
                    maxWidth: '520px',
                    width: '90%',
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
                    overflow: 'hidden',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    style={{
                        backgroundColor: '#0d6efd',
                        padding: '16px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                    }}
                >
                    <i
                        className="fa fa-info-circle"
                        style={{ fontSize: '22px', color: '#fff' }}
                    />
                    <h3 style={{ margin: 0, color: '#fff', fontSize: '18px', fontWeight: '600' }}>
                        Ride Info
                    </h3>
                </div>

                <div style={{ padding: '20px' }}>
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '24px 0', color: '#666' }}>
                            <i className="fa fa-spinner fa-spin" style={{ fontSize: '22px' }} />
                            <div style={{ marginTop: '10px', fontSize: '14px' }}>Loading ride info…</div>
                        </div>
                    ) : entries.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '16px 0', color: '#999', fontSize: '14px' }}>
                            No info available.
                        </div>
                    ) : (
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                            <tbody>
                            {entries.map(([key, value]) => (
                                <tr
                                    key={key}
                                    style={{ borderBottom: '1px solid #f0f0f0' }}
                                >
                                    <td
                                        style={{
                                            padding: '9px 12px 9px 0',
                                            fontWeight: '600',
                                            color: '#555',
                                            whiteSpace: 'nowrap',
                                            verticalAlign: 'top',
                                            width: '40%',
                                        }}
                                    >
                                        {formatLabel(key)}
                                    </td>
                                    <td
                                        style={{
                                            padding: '9px 0',
                                            color: '#222',
                                            wordBreak: 'break-all',
                                            verticalAlign: 'top',
                                        }}
                                    >
                                        {value === null || value === undefined || value === ''
                                            ? <span style={{ color: '#bbb' }}>–</span>
                                            : String(value)}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <button
                            onClick={onClose}
                            style={{
                                padding: '10px 28px',
                                backgroundColor: '#6c757d',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                lineHeight: '1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
